
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calculators/goal-planning-sip-lumpsum",
      function () {
        return require("private-next-pages/calculators/goal-planning-sip-lumpsum/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calculators/goal-planning-sip-lumpsum"])
      });
    }
  